<template>
  <div v-loading="isLoadingContents">
    <content-summary
      :meta="meta"
      :campaign="campaign"
      @change-filter-value="changeFilterValue($event)"
    >
    </content-summary>
    <el-divider />

    <contents-grid
      ref="contentsGrid"
      :data="contents"
      :is-admin="isAdmin"
      :selected-filter="selectedFilter"
      @delete-content="callAPI($event)"
      @show-edit-content-dialog="showEditContentDialog($event)"
      @show-text-dialog="showTextDialog($event)"
      @show-brief-dialog="showBriefDialog($event)"
      @selection-changed-grid="selectionChanged($event)"
      @grid-columns-controller="fetchColumnsController($event)"
      @reset-selected-filter="resetSelectedFilter($event)"
      @save-selected-fitlers="saveSelectedFilters($event)"
    >
      <template v-slot:entityButton>
        <div class="d-flex flex-row">
          <el-button
            plain
            type="secondary"
            size="small"
            :disabled="disabledBulkButton"
            class="bulk-publish-button"
            @click="showBulkPublishDialog()"
          >
            <i class="fas fa-edit"></i> {{ $t("bulkPublish") }}
          </el-button>
          <div>
            <grid-columns-button
              @update-grid-columns="updateGridColumns($event)"
              @open-column-visible-list="loadColumnsListFromController()"
              :data="gridColumns"
            >
            </grid-columns-button>
          </div>
          <add-entity-button
            v-if="links && links.create && bulkUpdate"
            @click="showAddContentDialog()"
            @open-bulk-change-dialog="showBulkChangeDialog()"
            @open-column-visible-list="loadColumnsListFromController()"
            @update-grid-columns="updateGridColumns($event)"
            :message="$t('addContent')"
            :data="gridColumns"
            :disabledBulkButton="disabledBulkButton"
          >
          </add-entity-button>
        </div>
      </template>
    </contents-grid>
    <el-divider />
    <add-content-dialog
      v-if="links && links.create && addContentDialogVisible"
      v-model="addContentDialogVisible"
      :title="$t('addContent')"
      :link="links.create"
      @add-entity="callAPI($event)"
    >
    </add-content-dialog>
    <edit-content-dialog
      v-if="editContentLink && editContentDialogVisible"
      v-model="editContentDialogVisible"
      :data="editContentLink.link"
      @update-content="callAPI($event)"
    >
    </edit-content-dialog>
    <text-dialog
      v-if="contentDialog"
      v-model="textDialogVisible"
      :studyId="String(campaign.studyId)"
      :text="contentDialog"
      :is-loading-text="isLoadingText"
      :is-admin="isAdmin"
      @update-text="updateContentText($event)"
      @update-content="updateContent($event)"
    >
    </text-dialog>
    <brief-dialog
      v-if="contentDialog && briefDialogVisible"
      v-model="briefDialogVisible"
      :content="contentDialog"
      @refresh-content="refreshContent($event)"
      @update-content="updateContent($event)"
    >
    </brief-dialog>
    <bulk-change-dialog
      v-if="bulkUpdate"
      v-model="bulkChangeDialogVisible"
      :bulkUpdate="bulkUpdate"
      @bulk-update-call="updateBulk($event)"
      :isContent="true"
    >
    </bulk-change-dialog>
    <bulk-publish-dialog
      v-if="bulkPublish && bulkPublishDialogVisible"
      v-model="bulkPublishDialogVisible"
      :bulkPublish="bulkPublish"
      :contents="formatContentToPublishInBulk()"
      @bulk-publish-call="publishBulk($event)"
    >
    </bulk-publish-dialog>
  </div>
</template>

<script>
import ContentsGrid from "@/pages/ContentManager/Contents/Grid";
import AddContentDialog from "@/pages/ContentManager/Contents/AddDialog";
import AddEntityButton from "@/components/CampaignManager/AddEntityButton";
import EditContentDialog from "@/pages/ContentManager/Contents/EditDialog";
import TextDialog from "@/pages/ContentManager/Contents/TextDialog";
import BriefDialog from "@/pages/ContentManager/Contents/BriefDialog";
import ContentSummary from "@/pages/ContentManager/Contents/ContentSummary";
import { errorHandlerMixin } from "@/mixins/errorHandlerMixin.js";
import BulkChangeDialog from "@/components/CampaignManager/BulkChangeDialog";
import GridColumnsButton from "@/components/CampaignManager/GridColumnsButton";
import BulkPublishDialog from "@/components/CampaignManager/BulkPublishDialog";

export default {
  mixins: [errorHandlerMixin],
  components: {
    ContentsGrid,
    AddContentDialog,
    AddEntityButton,
    EditContentDialog,
    TextDialog,
    BriefDialog,
    ContentSummary,
    BulkChangeDialog,
    GridColumnsButton,
    BulkPublishDialog,
  },
  props: {
    data: Array,
    links: Object,
    readCampaign: Object,
    bulkUpdate: Object,
    bulkPublish: Object,
    meta: Object,
    campaign: Object,
    isAdmin: Boolean,

  },
  data() {
    return {
      addContentDialogVisible: false,
      editContentDialogVisible: false,
      editContentLink: null,
      textDialogVisible: false,
      briefDialogVisible: false,
      contentDialog: null,
      isLoadingContents: false,
      isLoadingText: false,
      isLoadingBrief: false,
      contents: [],
      // meta: null,
      bulkChangeDialogVisible: false,
      selectedContents: [],
      columnController: null,
      gridColumns: null,
      selectedFilter: null,
      selectedFilterModel: null,
      isSettingFilter: false,
      bulkPublishDialogVisible: false,
    };
  },
  methods: {
    loadColumnsListFromController() {
      if (this.columnController)
        this.gridColumns = this.columnController.gridColumns
          .filter((column) => column.colDef.field != "selector")
          .map((filteredColumn) => {
            return {
              colId: filteredColumn.colId,
              headerName: filteredColumn.colDef.headerName,
              visible: filteredColumn.visible,
            };
          });
    },
    fetchColumnsController(columnController) {
      this.columnController = columnController;
      this.loadColumnsListFromController();
    },
    saveSelectedFilters(filterModel) {
      this.savedFilterModel = filterModel;
    },
    updateGridColumns(data) {
      if (data.column == "all") {
        let allColumnsIds = this.columnController.gridColumns.map(
          (column) => column.colId
        );
        this.columnController.setColumnsVisible(allColumnsIds, data.isVisible);
      } else
        this.columnController.setColumnVisible(data.column, data.isVisible);

      this.loadColumnsListFromController();
    },
    resetSelectedFilter(){
      this.selectedFilter = null;
    },
    changeFilterValue(value) {
      this.selectedFilter = value;
      this.$refs.contentsGrid.setFilter(value);
    },
    callAPI(details) {
      this.$apiV2[details.link.method.toLowerCase()](
        details.link.href,
        details.entity
      )
        .then((response) => {
          this.fetchContents();
        })
        .catch((error) => {
          console.log(error);
        });
    },
    fetchContents() {
      if (this.links && this.links.list) {
        this.isLoadingContents = true;
        this.$apiV2[this.links.list.method.toLowerCase()](this.links.list.href)
          .then((response) => {
            this.contents = response.data.data;
            this.refreshMeta();
            this.isLoadingContents = false;
          })
          .catch((error) => {
            console.log(error);
            this.isLoadingContents = false;
          });
      }
    },
    refreshContent(content) {
      this.isLoadingText = true;
      const link = content.links.read;
      const givenContent = content;
      this.$apiV2[link.method.toLowerCase()](link.href).then((response) => {
        const index = this.contents.findIndex(
          (ctt) => ctt.data.id == givenContent.data.id
        );
        let contentResponse = response.data;
        this.contentDialog = contentResponse;
        this.refreshMeta();
        this.$set(this.contents, index, contentResponse);
        this.isLoadingText = false;
      });
    },
    updateContentText(details) {
      this.isLoadingText = true;
      this.$apiV2[details.link.method.toLowerCase()](
        details.link.href,
        details.entity
      )
        .then((response) => {
          const index = this.contents.findIndex(
            (content) => content.data.id == this.contentDialog.data.id
          );
          let content = this.contents[index];
          content.data.text = { ...response.data.data };
          this.contentDialog = content;
          this.refreshMeta();

          this.$set(this.contents, index, content);
          this.isLoadingText = false;
        })
        .catch((error) => {
          this.$message({
            message: this.$i18n.t("errorMessage"),
            type: "error",
            duration: 6000,
          });
          console.log(error);
          this.isLoadingText = false;
        });
    },
    updateContent(details) {
      this.isLoadingText = true;
      this.$apiV2[details.link.method.toLowerCase()](
        details.link.href,
        details.entity
      )
        .then((response) => {
          this.fetchContents();
          this.contentDialog = response.data;
          this.refreshMeta();
          this.isLoadingText = false;
          this.$message({
            message: this.$i18n.t("contentUpdated"),
            type: "success",
            duration: 6000,
          });
        })
        .catch((error) => {
          this.isLoadingText = false;
          this.handleError(error);
        });
    },
    showAddContentDialog() {
      this.addContentDialogVisible = true;
    },
    showEditContentDialog(details) {
      this.editContentLink = details;
      this.editContentDialogVisible = true;
    },
    showTextDialog(content) {
      this.contentDialog = this.contents.find(
        (ctt) => ctt.data.id == content.id
      );
      this.textDialogVisible = true;
    },
    showBriefDialog(content) {
      this.contentDialog = this.contents.find(
        (ctt) => ctt.data.id == content.id
      );
      this.briefDialogVisible = true;
    },
    refreshMeta() {
      this.$apiV2[this.readCampaign.method.toLowerCase()](
        this.readCampaign.href
      ).then((response) => {
        this.$emit("refresh-meta", response.data.meta);
      });
    },
    showBulkChangeDialog() {
      this.bulkChangeDialogVisible = true;
    },
    showBulkPublishDialog() {
      this.bulkPublishDialogVisible = true;
    },
    updateBulk(data) {
      const request = {
        contentsIds: this.selectedContents,
        publishDate: data.publishDate,
        deliveryDate: data.deliveryDate,
        status: data.status,
        creationDate: data.creationDate,
        costPerWord: data.costPerWord,
        costPerWordWithoutMargin: data.costPerWordWithoutMargin,
        writingType: data.writingType,
      };
      this.$apiV2[this.bulkUpdate.method.toLowerCase()](
        this.bulkUpdate.href,
        request
      )
        .then((_) => {
          this.fetchContents();
        })
        .catch((error) => console.error(error));
    },
    publishBulk(data) {
      const contents = Object.entries(data).map(([key, value]) => {
        return {
          contentId: Number(key),
          publishedDate: value.publishedDate,
          url: value.url,
        }
      });
      if (contents.length == 0) {
        this.$message({
          message: this.$i18n.t("noContentToPublishWarning"),
          type: "warning",
          duration: 6000,
        });
        return;
      }
      const requestBody = {
        contents: contents,
        status: "PUBLISHED"
      }
      this.$apiV2[this.bulkPublish.method.toLowerCase()](
        this.bulkPublish.href,
        requestBody
      )
        .then((response) => {
          if (response.data.data.publishedContentsCount > 0) {
            this.$message({
              message: this.$i18n.t("publishBulkContentSuccess", { count: response.data.data.publishedContentsCount }),
              type: "success",
              duration: 6000,
            });
          }

          if (response.data.data.failedContentsIds.length > 0) {
            this.$message({
              message: this.$i18n.t("publishBulkContentFailure", { count: response.data.data.failedContentsIds.length }),
              type: "error",
              duration: 10000,
            });
          }

          this.fetchContents();
        })
        .catch((error) => console.error(error));
    },
    selectionChanged(rows) {
      this.selectedContents = rows.map((element) => element.id);
    },
    formatContentToPublishInBulk(){
      if (this.contents && this.selectedContents) {
        return this.contents.filter(content => this.selectedContents.includes(content.data.id)).map(content => {
          return {
            contentId: content.data.id,
            text: content.data.keyword ? content.data.keyword.text : "",
            url: content.data.url,
            status: content.data.contentStatus,
          }
        });
      }
    } 
  },
  computed: {
    disabledBulkButton() {
      return this.selectedContents.length <= 0;
    },
  },
  mounted() {
    this.fetchContents();
  },
};
</script>

<style scoped>
.bulk-publish-button {
  margin-right: 10px;
}
</style>

<i18n>
{
  "en": {
    "addContent": "Add a content",
    "errorMessage": "We encountered an error",
    "contentUpdated": "Content updated",
    "bulkPublish": "Publish contents in bulk",
    "publishBulkContentSuccess": "{count} contents have been published successfully",
    "publishBulkContentFailure": "{count} contents failed to publish",
    "noContentToPublishWarning": "Please fill in at least one content to publish."
  },
  "fr": {
    "addContent": "Ajouter un contenu",
    "errorMessage": "Nous avons rencontré une erreur",
    "contentUpdated": "Contenu mis à jour",
    "bulkPublish": "Publication multiple",
    "publishBulkContentSuccess": "{count} contenus ont été publiés avec succès",
    "publishBulkContentFailure": "{count} contenus n'ont pas pu être publiés",
    "noContentToPublishWarning": "Veuillez ajouter au moins un contenu à publier."
  },
  "de": {
    "addContent": "Inhalt hinzufügen",
    "errorMessage": "Es ist ein Fehler aufgetreten",
    "contentUpdated": "Inhalt aktualisiert",
    "bulkPublish": "Inhalte in Bulk veröffentlichen",
    "publishBulkContentSuccess": "{count} Inhalte wurden erfolgreich veröffentlicht",
    "publishBulkContentFailure": "{count} Inhalte konnten nicht veröffentlicht werden",
    "noContentToPublishWarning": "Bitte fügen Sie mindestens einen Inhalt zum Veröffentlichen hinzu."
  }
}
</i18n>
